module.exports = __webpack_public_path__ + "img/reference11.ebe11165.jpg";